import React, { useState, useEffect } from 'react';
import { ScheduleMeeting } from 'react-schedule-meeting';
import SelectField from "../../../components/fields/SelectField";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { scheduleDays} from './utils';
import { useLocation } from 'react-router-dom';
import  DialogDefault  from '../event_create_edit/components/steps/DialogDefault'
import FromFilling from './formFilling'; // Adjust the import path as needed
import SubmissionConfirmation from './submissionConfirmation'
import { useParams } from 'react-router-dom';
import { Mixpanel } from '../../../mixpanel/MixpanelTrack';
import { EVENTS } from  '../../../mixpanel/mixpanelEvent';
import { AgentPage } from './AgentPage'
enum Stage {
  DateAndTimeSelection,
  FormFilling,
  FormSubmitted
}

type TimeSlot = {
  id: number;
  startTime: string;
  endTime: string;
};

type FileData = {
  startTime?: string;
  endTime?: string;
  fromTimeZone?: string;
  date?: string;
  duration?: string;
  toTimeZone?: string;
  days?: string;
  unavailableDays?: [];
  unavailableTimeSlots?:[];
  unavailableDates?:[];
  selectedTimeSlots?:[];
};

interface FormData {
  name: string;
  email: string;
  phoneNumber: string;
  acceptTerms: boolean;
}
const MeetingPage = () => {
  const [open, setOpen] = React.useState(false);
  const { link1, link2 } = useParams();
  // const [isUserSelected, setIsUserSelected] = useState(false); // State to track user selection
  const [currentStage, setCurrentStage] = useState(Stage.DateAndTimeSelection);
  const [showVideo, setShowVideo] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const [title, setTitle] = useState('');
  const [timeString, setTimeString] = useState('');
  const [eventId, setEventId] = useState('');
  const [email, setEmail] = useState('');
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [videoStarted, setVideoStarted] = useState(false);
  const [selectedtime, setSelectedtime] = useState({fromTimezone:"", toTimezone:""});
  const [meetingData, setMeetingData] = useState({
    meetingDuration: 0,
    timeSlots: [],
    fileData: {},
    updateKey: Date.now(),
    meetingUrl: '',
    title: '',
    description: '',
    imgUrl:''
  });
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let selectedTimeSlots:string[] = [];

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const onMeetingTimeSelect = async (time:any) => {
    setOpen(true);
    const startTime = time.availableTimeslot.startTime;
    const endTime = time.availableTimeslot.endTime;

    const payload = {
      ...selectedtime,
      startTime:startTime,
      endTime:endTime
    };
    const response = await axios.post("https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api/selectedtimeslot", payload, {
      headers: { "Content-Type": "application/json; charset=utf-8" }
    });
    setDisplayText(response.data.displayText);
    setTimeString(response.data.time);
   

  };


  const fetchEventDetailsByUrl = async (url:string) => {
    try {
      
      const response = await axios.get(`https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api/meeting?meetingLink=${url}`);
      return response.data[0]; 
    } catch (error) {
      console.error("Error fetching event details:", error);
      throw error; // Rethrow the error for the caller to handle
    }
  };

  const fetchAvailableTimeSlots = async (payload:FileData) => {
    try {
      const response = await axios.post("https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api/avaliabeTimeSlots", payload, {
        headers: { "Content-Type": "application/json; charset=utf-8" }
      });
      return response.data.availableTimeslots;
    } catch (error) {
      console.error("Error fetching converted time:", error);
      throw error; // Rethrow the error for the caller to handle
    }
  };

  useEffect(() => {
    const fetchData = async () => {

      try {
        const meetingUrl = `/${link1}/${link2}`;


        const data = await fetchEventDetailsByUrl(meetingUrl);
        const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const payload:FileData = {
          startTime: data.startTime,
          endTime: data.endTime,
          fromTimeZone: data.timezone,
          date: data.eventDate,
          duration: data.meetingDuration,
          toTimeZone: localTimezone,
          days: data.scheduleDays,
          unavailableDays:data.unavailableDays,
          unavailableTimeSlots:data.unavailableTimeSlots,
          unavailableDates:data.unavailableDates,
          selectedTimeSlots:data && data.selectedTimeSlots ? data.selectedTimeSlots : []
        };

        const availableTimData = await fetchAvailableTimeSlots(payload);

        if(availableTimData) {

          const newMeetingData = {
            meetingDuration: +data.meetingDuration,
            timeSlots: availableTimData || [],
            fileData: payload,
            updateKey: Date.now(),
            meetingUrl: `https://iframe.mediadelivery.net/embed/73765/${data.videoId}?autoplay=true`,
            imgUrl:`https://vz-7fe72e56-151.b-cdn.net/${data.videoId}/preview.gif`,
            title: data.eventTitle,
            description: data.eventDescription,

          };
          if(data && data.videoId && data.videoId !== "") {
            setShowVideo(true);
          } else {
            setShowVideo(false);
          }
          setSelectedtime({fromTimezone:data.timezone, toTimezone:localTimezone});
          setMeetingData(newMeetingData);
          setEventId(data.eventId);
          console.log(data.eventTitle);
          setTitle(data.eventTitle);
          //  
          if(data && data.selectedTimeSlots) {
            setSelectedSlots(data.selectedTimeSlots);
          }
          setEmail(data.email);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (link1) {
      fetchData();
    }
  }, [link1]);

      const timezoneOptions = [{ value: userTimezone, label: userTimezone}];

      const handleVideoStart = () => {
        setVideoStarted(true);
      };

      const handleCancel = () => {
        setOpen(!open);
      }

      const handleConfirm = () => {
        setOpen(!open);
        setCurrentStage(Stage.FormFilling);
      }

      const handleLeft = () => {
        setCurrentStage(Stage.DateAndTimeSelection);
      }

      const handleSubmit = async (formData: FormData) => {
        setIsLoading(true);
        const payload = {fromTimezone:selectedtime.toTimezone, toTimezone:selectedtime.fromTimezone, timeString:timeString};
        try {
        const payloadData = {...payload,eventId, title,  ...formData, eventEmail:email, selectedSlots};
        Mixpanel.track(EVENTS.meeting_create_sucessfully, { requestEmail: email, data:payloadData });
          const response = await axios.post("https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api/confrimMeeting", payloadData, {
            headers: { "Content-Type": "application/json; charset=utf-8" }
          });


   

          setCurrentStage(Stage.FormSubmitted);
          setIsLoading(false);

        } catch (error) {
          console.error("Error fetching converted time:", error);
          throw error; // Rethrow the error for the caller to handle
        }
      }
      const onBackToSchedule = () => {
        setCurrentStage(Stage.DateAndTimeSelection);
      }
      
      return (
        <div className="animate-fadeIn">
        <DialogDefault handleCancel={handleCancel} handleConfirm={handleConfirm}  open={open} displayText={displayText}/>
          <header className="bg-gray-800 text-white p-4 text-xl font-bold">
           Frontdesk 24
          </header>
    
     
          <div className="flex flex-col md:flex-row h-screen">

            <div className="w-full md:w-1/2 p-2">
              <h1 className="text-2xl font-bold my-2">{meetingData.title}</h1>
            <div style={{ position: "relative", paddingTop: '16.25%', marginTop: 0 }}>
              <AgentPage />
            </div>
              
            </div>
            <div className="w-full md:w-1/2 p-2 bg-gray-100">
            {currentStage === Stage.DateAndTimeSelection  && (  <ScheduleMeeting 
                key={meetingData.updateKey}
                availableTimeslots={meetingData.timeSlots}
                borderRadius={20}
                eventDurationInMinutes={meetingData.meetingDuration}
                onStartTimeSelect={onMeetingTimeSelect}
              />)}
            {currentStage === Stage.FormFilling && ( <FromFilling handleBack={handleLeft} handleSubmit={handleSubmit} isLoading={isLoading} />
            )}
             {currentStage === Stage.FormSubmitted && (<SubmissionConfirmation onBackToSchedule={onBackToSchedule} displayText={displayText}  />
              )}  
              <SelectField
                id="select_timezone"
                label="Select TimeZone *"
                placeholder={userTimezone}
                options={timezoneOptions}
              />

            </div>
          </div>
       
        </div>
      );
      
};

export default MeetingPage;
